export default __webpack_public_path__ + "static/media/Estimate_03.18e23407.png";